import axios, {AxiosPromise} from "axios";

export interface QueryParams {
  pageNumber?: number;
  pageSize?: number;
  [key: string]: any;
}

export interface CancellationHandlers {
  cancelToken?: any;
  signal?: AbortSignal;
  [key: string]: any;
}

export const GET_LAW_AGENTS = '/law/getLawAgents';
export const GET_LAW_AGENTS_EXCEL = '/law/getLawAgentsForExcelFile';
export const UPLOAD_LAW_AGENTS = '/law/uploadLawAgents';
export const GET_LAW_TRANSACTIONS = '/law/getLawTransactions';
export const GET_LAW_TRANSACTIONS_EXCEL = '/law/getLawTransactionsForExcelFile';
export const UPLOAD_LAW_TRANSACTIONS = '/law/uploadLawTransactions';

export function getLawAgents(
  queryParams: QueryParams,
  cancellationHandlers?: CancellationHandlers
): AxiosPromise<any> {
  return axios.get(GET_LAW_AGENTS, {
    params: queryParams,
    ...cancellationHandlers
  });
}

export function getLawTransactions(
  queryParams: QueryParams,
  cancellationHandlers?: CancellationHandlers
): AxiosPromise<any> {
  return axios.get(GET_LAW_TRANSACTIONS, {
    params: queryParams,
    ...cancellationHandlers
  });
}

export function getLawAgentsForExcelFile(queryParams: QueryParams): AxiosPromise<any> {
  return axios.get(GET_LAW_AGENTS_EXCEL, {
    params: queryParams
  });
}

export function getLawTransactionsForExcelFile(queryParams: QueryParams): AxiosPromise<any> {
  return axios.get(GET_LAW_TRANSACTIONS_EXCEL, {
    params: queryParams
  });
}

export function uploadLawAgents(formData: FormData) {

  return axios.post(
    UPLOAD_LAW_AGENTS,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
};

export function uploadLawTransactions(formData: FormData) {

  return axios.post(
    UPLOAD_LAW_TRANSACTIONS,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
};